import React from "react";
import { serviceActions } from "../assets/serviciosDetalle";

export default function ServiceCta({ service, id = undefined }) {
    const emailLabel = service.contactEmail || serviceActions.emailLabel;
    const emailHref = service.contactEmail
        ? `mailto:${service.contactEmail}`
        : serviceActions.email;

    return (
        <section className="service-detail-cta" id={id}>
            <div className="service-detail-inner">
                <h2>{service.ctaTitle}</h2>
                <p>{service.ctaText}</p>
                <div className="service-cta-actions">
                    <a href={serviceActions.whatsapp}>Contactar por WhatsApp</a>
                    <a href={emailHref}>{emailLabel}</a>
                </div>
            </div>
        </section>
    );
}
